import { observer } from 'mobx-react';
import { FC, useEffect, useMemo } from 'react';
import ModifierAndExclusionModalHeader from './containers/ModifierAndExclusionModalHeader/ModifierAndExclusionModalHeader';
import ModifierAndExclusionModalContent from './containers/ModifierAndExclusionModalItems/ModifierAndExclusionModalItems';
import { mdfAndExclModalStore } from './store';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalFooter from 'src/view/components/Controls/Modal/ModalFooter/ModalFooter';
import ModalHeader from 'src/view/components/Controls/Modal/ModalHeader/ModalHeader';
import Pagination from 'src/view/components/Controls/PaginationOld/PaginationOld';
import LoadingOverlay from 'src/view/components/LoadingOverlay/LoadingOverlay';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { BUTTON_TITLE } from '~/constants/main';

const ModifierAndExclusionModal: FC = observer((): JSX.Element => {
  useEffect(() => {
    mdfAndExclModalStore.initStore();
  }, []);

  const modalClassName = useMemo((): string => {
    return !mdfAndExclModalStore.isOnlyModifiers || mdfAndExclModalStore.isMulti ? 'custom-modal' : 'custom-modal_single-choice';
  }, [mdfAndExclModalStore.isOnlyModifiers, mdfAndExclModalStore.isMulti]);

  return (
    <CustomModalComponent isOpen className={modalClassName} onRequestClose={mdfAndExclModalStore.closeModal} withCloseIcon>
      <ModalBackground>
        <ModalHeader title={localeStore.t('add_modifier_or_exclusion')} />
        <ModifierAndExclusionModalHeader />
        <div className="d-flex flex-1 flex-column px-8">
          {/* modifiers or exclusions list */}
          <ScrollableBlock showScrollbar className="d-flex flex-1" scrollClassName="full-height">
            <ul className="custom-modal__container mb-2">
              <ModifierAndExclusionModalContent />
            </ul>
          </ScrollableBlock>
          {/* pagination */}
          <Pagination
            pagination={mdfAndExclModalStore.pagination}
            onChange={mdfAndExclModalStore.fetchData}
            className="mt-2"
            hidden={mdfAndExclModalStore.isSelectedCrumb}
          />
          {/* loading overlay */}
          <LoadingOverlay visible={mdfAndExclModalStore.loading} />
        </div>

        {/* save button */}
        <ModalFooter>
          <Button
            title={localeStore.t(BUTTON_TITLE.SAVE)}
            onClick={mdfAndExclModalStore.clickSave}
            loading={mdfAndExclModalStore.loading}
            size="large"
          />
        </ModalFooter>
      </ModalBackground>
    </CustomModalComponent>
  );
});

export default ModifierAndExclusionModal;
